import { render, staticRenderFns } from "./custom-link.vue?vue&type=template&id=67bef600&scoped=true&"
import script from "./custom-link.vue?vue&type=script&lang=js&"
export * from "./custom-link.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67bef600",
  null
  
)

export default component.exports